import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar as CalendarComponent } from '@/components/ui/calendar';
import { format } from 'date-fns';
import axios from 'axios';

import { API_BASE as API } from '@/utils/api';

export const CompareModal = ({ isOpen, onClose }) => {
  const [date1, setDate1] = useState(null);
  const [date2, setDate2] = useState(null);
  const [comparison, setComparison] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCompare = async () => {
    if (!date1 || !date2) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/mood/compare?date1=${format(date1, 'yyyy-MM-dd')}&date2=${format(date2, 'yyyy-MM-dd')}`);
      setComparison(res.data);
    } catch (err) {
      console.error('Compare error:', err);
    }
    setLoading(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="apple-card border-0 max-w-md modal-mobile-optimized modal-glow">
        <DialogHeader>
          <DialogTitle className="apple-headline text-lg">Compare Moods</DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            {[{ date: date1, setDate: setDate1, label: 'Date 1' }, { date: date2, setDate: setDate2, label: 'Date 2' }].map(({ date, setDate, label }, i) => (
              <Popover key={i}>
                <PopoverTrigger asChild>
                  <button className="apple-button w-full text-left text-sm" data-testid={`compare-date${i+1}-btn`}>
                    <Calendar size={14} className="inline mr-2" />
                    {date ? format(date, 'MMM dd') : label}
                  </button>
                </PopoverTrigger>
                <PopoverContent className="apple-card p-0 border-0">
                  <CalendarComponent mode="single" selected={date} onSelect={setDate} />
                </PopoverContent>
              </Popover>
            ))}
          </div>
          <button 
            onClick={handleCompare} 
            disabled={!date1 || !date2 || loading} 
            className="apple-button apple-button-primary w-full"
            data-testid="compare-submit-btn"
          >
            {loading ? 'Comparing...' : 'Compare'}
          </button>
          {comparison && (
            <div className="p-4 rounded-xl" style={{ background: 'var(--apple-bg-secondary)' }}>
              <div className="grid grid-cols-2 gap-4">
                {[comparison.date1, comparison.date2].map((d, i) => (
                  <div key={i} className="text-center">
                    <div className="text-xs mb-1" style={{ color: 'var(--apple-text-tertiary)' }}>
                      {d?.date}
                    </div>
                    <div 
                      className="text-lg font-bold capitalize"
                      style={{ color: d?.color || 'var(--apple-text-primary)' }}
                    >
                      {d?.adjective || 'N/A'}
                    </div>
                    <div className="text-xs mt-1" style={{ color: 'var(--apple-text-tertiary)' }}>
                      {d?.intensity ? `${Math.round(d.intensity * 100)}% intensity` : ''}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
